import EquinetCore from './EquinetCore';

export default EquinetCore;
